import { XIcon } from '$components'
import { ReactNode } from 'react'
import { cn } from '$components'
import { useModal } from './context'

export type ModalHeaderProps = {
  children?: ReactNode,
  className?: string,
}

export function ModalHeader({ children, className }: ModalHeaderProps) {
  const { close } = useModal()

  return (
    <div className={cn('flex p-6 justify-between items-center w-full border-b border-gray-100', className)}>
      <div className="flex flex-col w-full gap-1">
        { children}
      </div>

      <button
        type="button"
        onClick={close}
        className="p-2 border border-transparent hover:border-gray-100 hover:bg-white rounded-xl transition-colors"
      >
        <XIcon className="size-4 text-gray-700" />
      </button>
    </div>
  )
}
